import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FileText, AlertCircle, Scale, Gavel } from 'lucide-react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <main className="py-12 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <article className="bg-gray-800 rounded-2xl p-8 md:p-12 border border-gray-700">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Conditions Générales d'Utilisation
              </h1>
              <p className="text-gray-400 text-sm mb-8">
                Dernière mise à jour : 26 novembre 2025
              </p>
              
              <div className="prose prose-invert max-w-none">
                <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                  Les présentes Conditions Générales d'Utilisation (ci-après "CGU") régissent l'utilisation du site web galo-bet.com (ci-après "le Site") exploité par Galo Bet. En accédant et en utilisant ce Site, vous acceptez d'être lié par ces CGU. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre Site.
                </p>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center space-x-2">
                    <FileText className="text-pink-400" size={28} />
                    <span>1. Acceptation des Conditions</span>
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    En accédant au Site, vous reconnaissez avoir lu, compris et accepté d'être lié par les présentes CGU ainsi que par toutes les lois et réglementations applicables. Si vous n'acceptez pas ces conditions, vous devez immédiatement cesser d'utiliser le Site.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Nous nous réservons le droit de modifier ces CGU à tout moment. Toute modification entrera en vigueur dès sa publication sur le Site. Il est de votre responsabilité de consulter régulièrement ces CGU pour prendre connaissance de toute modification.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center space-x-2">
                    <AlertCircle className="text-pink-400" size={28} />
                    <span>2. Description du Service</span>
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Galo Bet est un site de comparaison et d'évaluation indépendant qui fournit des informations, des guides, des avis et des actualités concernant les sites de paris en ligne en France. Notre Site sert uniquement de plateforme informative et éducative.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    <strong>Important :</strong> Galo Bet n'exploite pas de site de paris en ligne et n'accepte pas de paris. Nous ne sommes qu'un service d'information et de comparaison. Tous les paris sont effectués directement sur les sites des opérateurs agréés que nous présentons.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Nous pouvons recevoir une commission d'affiliation lorsque vous cliquez sur nos liens vers des sites de paris et que vous vous inscrivez via ces liens. Cette rémunération n'influence jamais nos avis, évaluations ou classements, qui restent toujours indépendants et objectifs.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">3. Utilisation du Site</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Vous vous engagez à utiliser le Site uniquement à des fins légales et conformément aux présentes CGU. Vous acceptez de ne pas :
                  </p>
                  <ul className="text-gray-300 space-y-2 ml-6 mb-4">
                    <li>Utiliser le Site de manière à violer les lois applicables</li>
                    <li>Reproduire, dupliquer, copier, vendre ou exploiter commercialement tout ou partie du Site</li>
                    <li>Tenter d'accéder de manière non autorisée à tout système, réseau ou compte lié au Site</li>
                    <li>Introduire des virus, codes malveillants ou tout autre élément nuisible</li>
                    <li>Utiliser des robots, scripts automatisés ou tout autre moyen pour extraire des données du Site</li>
                    <li>Perturber ou interrompre le fonctionnement du Site</li>
                  </ul>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center space-x-2">
                    <Scale className="text-pink-400" size={28} />
                    <span>4. Propriété Intellectuelle</span>
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Tout le contenu présent sur le Site, incluant mais sans s'y limiter : textes, graphiques, logos, icônes, images, clips audio, téléchargements numériques, et compilations de données, est la propriété de Galo Bet ou de ses fournisseurs de contenu et est protégé par les lois françaises et internationales sur la propriété intellectuelle.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Vous pouvez consulter, télécharger et imprimer des pages du Site pour votre usage personnel et non commercial uniquement. Toute autre utilisation, y compris la reproduction, la distribution, la modification ou la création d'œuvres dérivées, est strictement interdite sans autorisation écrite préalable de Galo Bet.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">5. Exactitude des Informations</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Nous nous efforçons de fournir des informations exactes, à jour et complètes sur le Site. Cependant, nous ne garantissons pas l'exactitude, l'exhaustivité ou l'actualité de toutes les informations présentées. Les informations sont fournies "en l'état" sans garantie d'aucune sorte.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Les promotions, bonus et offres présentées peuvent être modifiées par les opérateurs à tout moment. Il est de votre responsabilité de vérifier les conditions actuelles directement sur le site de l'opérateur avant de vous engager.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">6. Limitation de Responsabilité</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Dans les limites autorisées par la loi, Galo Bet ne pourra être tenu responsable de :
                  </p>
                  <ul className="text-gray-300 space-y-2 ml-6 mb-4">
                    <li>Dommages directs, indirects, accessoires, consécutifs ou punitifs résultant de l'utilisation ou de l'impossibilité d'utiliser le Site</li>
                    <li>Pertes financières résultant de vos activités de paris sur les sites tiers</li>
                    <li>Erreurs, omissions ou inexactitudes dans le contenu du Site</li>
                    <li>Interruptions ou défaillances du Site pour quelque raison que ce soit</li>
                    <li>Virus ou autres codes malveillants qui pourraient être transmis via le Site</li>
                    <li>Actions des sites de paris tiers que nous présentons</li>
                  </ul>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Votre utilisation du Site se fait à vos propres risques. Vous êtes seul responsable de toutes les décisions que vous prenez concernant les paris en ligne et des conséquences qui en découlent.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">7. Liens vers des Sites Tiers</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Notre Site contient des liens vers des sites web de tiers, notamment des sites de paris en ligne. Ces liens sont fournis uniquement pour votre commodité. Nous n'avons aucun contrôle sur le contenu de ces sites tiers et n'assumons aucune responsabilité concernant leur contenu, leurs pratiques de confidentialité ou leurs politiques.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    L'inclusion d'un lien vers un site tiers ne constitue pas une approbation de notre part. Vous utilisez ces sites tiers à vos propres risques et vous devez lire leurs conditions d'utilisation et politiques de confidentialité.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">8. Jeu Responsable</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Le paris en ligne doit être une activité de divertissement et non une source de revenus. Nous encourageons fortement le jeu responsable et vous rappelons que :
                  </p>
                  <ul className="text-gray-300 space-y-2 ml-6 mb-4">
                    <li>Le paris en ligne est réservé aux personnes majeures (18 ans et plus en France)</li>
                    <li>Vous ne devez jamais parier plus que ce que vous pouvez vous permettre de perdre</li>
                    <li>Si vous pensez avoir un problème de jeu, consultez les ressources disponibles sur notre page <a href="/responsible-gaming" data-discover="true" className="text-pink-400 hover:text-pink-300">Jeu Responsable</a></li>
                    <li>Des outils de jeu responsable sont disponibles sur tous les sites agréés français</li>
                  </ul>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center space-x-2">
                    <Gavel className="text-pink-400" size={28} />
                    <span>9. Droit Applicable et Juridiction</span>
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Les présentes CGU sont régies par les lois françaises. Tout litige relatif à l'interprétation ou à l'exécution des présentes CGU sera de la compétence exclusive des tribunaux français.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Si une disposition des présentes CGU est jugée invalide ou inapplicable, les autres dispositions resteront en vigueur. La disposition invalide sera remplacée par une disposition valide qui se rapproche le plus de l'intention de la disposition originale.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">10. Contact</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Pour toute question concernant ces Conditions Générales d'Utilisation, vous pouvez nous contacter :
                  </p>
                  <div className="bg-gray-700 rounded-lg p-6 mb-4">
                    <p className="text-gray-300 mb-2"><strong>Email :</strong> <a href="mailto:info@galo-bet.com" className="text-pink-400 hover:text-pink-300">info@galo-bet.com</a></p>
                    <p className="text-gray-300 mb-2"><strong>Téléphone :</strong> <a href="tel:+33519286219" className="text-pink-400 hover:text-pink-300">+33 5 19 28 62 19</a></p>
                    <p className="text-gray-300"><strong>Adresse :</strong> Paris, France</p>
                  </div>
                </section>
              </div>
            </article>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;

